interface FieldLimit {
  min?: number;
  max?: number;
  description: string;
}

export const FIELD_LIMITS: Record<string, FieldLimit> = {
  key_metrics: {
    max: 3,
    description: "2-3 standout metrics that demonstrate tangible value"
  },
  challenges: {
    max: 3,
    description: "2-3 bullet points summarizing key issues that needed to be overcome"
  },
  objectives: {
    max: 3,
    description: "2-3 short phrases describing RISCPoint's strategic plan and methodology"
  },
  outcomes: {
    max: 3,
    description: "2-3 major accomplishments with titles and descriptions"
  },
  partnership_details: {
    min: 2,
    max: 4,
    description: "2-4 detailed points explaining how RISCPoint helped the client achieve outcomes"
  }
}

interface FieldLimitsResult {
  isValid: boolean;
  error: string | null;
}

export const getFieldLimits = (fieldName: string): FieldLimit | null => {
  return FIELD_LIMITS[fieldName] || null
}

export const validateFieldLength = (fieldName: string, value: unknown[]): FieldLimitsResult => {
  const limits = getFieldLimits(fieldName)
  if (!limits) {
    return { isValid: true, error: null }
  }
  
  const length = Array.isArray(value) ? value.length : 0
  
  if (limits.min && length < limits.min) {
    return { 
      isValid: false, 
      error: `Minimum ${limits.min} items required` 
    }
  }
  
  if (limits.max && length > limits.max) {
    return { 
      isValid: false, 
      error: `Maximum ${limits.max} items allowed` 
    }
  }
  
  return { isValid: true, error: null }
}

export const canAddMoreItems = (fieldName: string, currentValue: unknown[]): boolean => {
  const limits = getFieldLimits(fieldName)
  if (!limits || !limits.max) return true
  
  const length = Array.isArray(currentValue) ? currentValue.length : 0
  return length < limits.max
}

export const canRemoveItems = (fieldName: string, currentValue: unknown[]): boolean => {
  const limits = getFieldLimits(fieldName)
  if (!limits || !limits.min) return true
  
  const length = Array.isArray(currentValue) ? currentValue.length : 0
  return length > limits.min
}
